import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfileComponent } from './profile/profile.component';
import { MyPipesModule } from '../common/my-pipes.module';
import { WarningBoxComponent } from './warning-box/warning-box.component';
import { ClientBillingComponent } from './client-billing/client-billing.component';
// import { SearchPipe } from '../common/search.pipe';

@NgModule({
  declarations: [ProfileComponent, WarningBoxComponent, ClientBillingComponent],
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    MyPipesModule,
  ],
})
export class HumanResourceModule {}
